export const FETCH_WHITELIST_DETAILS = 'FETCH_WHITELIST_DETAILS';
export const FETCH_WHITELIST_DETAILS_SUCCESS =
  'FETCH_WHITELIST_DETAILS_SUCCESS';
export const FETCH_WHITELIST_DETAILS_FAIL = 'FETCH_WHITELIST_FAIL';
export const SELECT_WHITELIST_ID = 'SELECT_WHITELIST_ID';
export const SELECT_WHITELIST_CUSTOMERS = 'SELECT_WHITELIST_CUSTOMERS';
export const UPDATE_WHITELIST_NAME = 'UPDATE_WHITELIST_NAME';
export const UPDATE_WHITELIST_NAME_SUCCESS = 'UPDATE_WHITELIST_NAME_SUCCESS';
export const UPDATE_WHITELIST_NAME_FAIL = 'UPDATE_WHITELIST_NAME_FAIL';
export const APPROVE_CUSTOMERS = 'APPROVE_CUSTOMERS';
export const APPROVE_CUSTOMERS_SUCCESS = 'APPROVE_CUSTOMERS_SUCCESS';
export const APPROVE_CUSTOMERS_FAIL = 'APPROVE_CUSTOMERS_FAIL';
export const DELETE_CUSTOMERS = 'DELETE_CUSTOMERS';
export const DELETE_CUSTOMERS_SUCCESS = 'DELETE_CUSTOMERS_SUCCESS';
export const DELETE_CUSTOMERS_FAIL = 'DELETE_CUSTOMERS_FAIL';
export const CLOSE_SUCCESS_MSG_POPUP = 'CLOSE_SUCCESS_MSG_POPUP';

export const fetchWhiteListDetails = ({
  id,
  currentPage,
  pageSize,
  filters
}) => ({
  type: FETCH_WHITELIST_DETAILS,
  payload: { id, currentPage, pageSize, filters }
});

export const fetchWhiteListDetailsSuccess = ({ whitelistDetails }) => ({
  type: FETCH_WHITELIST_DETAILS_SUCCESS,
  payload: { whitelistDetails }
});

export const fetchWhiteListDetailsFail = (message) => ({
  type: FETCH_WHITELIST_DETAILS_FAIL,
  payload: { message }
});

export const selectWhitelistIds = (selectedIds) => ({
  type: SELECT_WHITELIST_ID,
  payload: selectedIds
});

export const selectWhitelistCustomers = (selectedCustomers) => ({
  type: SELECT_WHITELIST_CUSTOMERS,
  payload: selectedCustomers
});

export const updateWhitelistName = ({ id, name }) => ({
  type: UPDATE_WHITELIST_NAME,
  payload: { id, name }
});

export const updateWhitelistNameSuccess = () => ({
  type: UPDATE_WHITELIST_NAME_SUCCESS
});

export const updateWhitelistNameFail = (message) => ({
  type: UPDATE_WHITELIST_NAME_FAIL,
  payload: { message }
});

export const approveCustomers = ({ customerIds, whitelistId }) => ({
  type: APPROVE_CUSTOMERS,
  payload: { customerIds, whitelistId }
});

export const approveCustomersSuccess = () => ({
  type: APPROVE_CUSTOMERS_SUCCESS
});

export const approveCustomersFail = (message) => ({
  type: APPROVE_CUSTOMERS_FAIL,
  payload: { message }
});

export const deleteCustomers = ({ customerIds, whitelistId }) => ({
  type: DELETE_CUSTOMERS,
  payload: { customerIds, whitelistId }
});

export const deleteCustomersSuccess = () => ({
  type: DELETE_CUSTOMERS_SUCCESS
});

export const deleteCustomersFail = (message) => ({
  type: DELETE_CUSTOMERS_FAIL,
  payload: { message }
});

export const closeSuccessMsgPopup = () => ({
  type: CLOSE_SUCCESS_MSG_POPUP
});
